module.exports = __webpack_public_path__ + "img/logo_wph.f0bb26c2.png";